import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { BranchContainerModel } from '../../../../../models/aggregates/branch'
import { ApiVisa, BaseApiTemplateService, BasicApiResponseModel, Core2Config, Pagination, PagingResponseModel } from '../shared';

@Injectable({
  providedIn: 'root'
})
export class T2TBranchService extends BaseApiTemplateService<BranchContainerModel> {

  constructor(http: HttpClient) {
    super();
    this.endpoint_path = Core2Config.T2T_DOMAIN_URL_PREFIX + Core2Config.CONFIG_PREFIX + Core2Config.ERP_PREFIX + 'branches';
    this.httpClient = http;
  }

  getTenantBranches(pagination: Pagination, tenantCode: string,  visa: ApiVisa): Observable<PagingResponseModel<BranchContainerModel>> {
    if (this.endpoint_path && visa.api_domain_url) {
      this.apiUrl = visa.api_domain_url + this.endpoint_path + '/' + tenantCode;
    }
    const UrlByCriteria = this.apiUrl + '/query?' + pagination.getQueryKeyValues();
    return this.httpClient.get<PagingResponseModel<BranchContainerModel>>(
      UrlByCriteria,
      this.getHttpHeader(visa)
    );
  }

  public getTenantBranchByGuid(guid: string, tenantCode: string, visa: ApiVisa): Observable<BasicApiResponseModel<BranchContainerModel>> {
    if (this.endpoint_path && visa.api_domain_url) {
      this.apiUrl = visa.api_domain_url + this.endpoint_path + '/' + tenantCode
    }
    return this.httpClient.get<BasicApiResponseModel<BranchContainerModel>>(
      this.apiUrl + '/query?' + "hdr_guids=" + guid,
      this.getHttpHeader(visa)
    );
  }

}